function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  id: "noun_Upload_503444",
  transform: "translate(801 61)"
}, React.createElement("g", {
  id: "Group_13",
  "data-name": "Group 13",
  transform: "translate(-808 -72)"
}, React.createElement("g", {
  id: "Group_12",
  "data-name": "Group 12"
}, React.createElement("path", {
  id: "Path_31",
  "data-name": "Path 31",
  d: "M0,0,13.333-.508l3.344,6.222L23.888,8.8l6.33-2.076,4.4-7.235L49,0V20H0Z",
  transform: "translate(8 33)",
  fill: "#fff"
}), React.createElement("path", {
  id: "Path_29",
  "data-name": "Path 29",
  d: "M56,31H42a1,1,0,0,0-1,1,9,9,0,0,1-18,0,1,1,0,0,0-1-1H8a1,1,0,0,0-1,1V52a1,1,0,0,0,1,1H56a1,1,0,0,0,1-1V32A1,1,0,0,0,56,31ZM55,51H9V33H21.045a11,11,0,0,0,21.91,0H55Z",
  fill: "#424b58"
}), React.createElement("path", {
  id: "Path_30",
  "data-name": "Path 30",
  d: "M26.707,18.707,31,14.414V28a1,1,0,0,0,2,0V14.414l4.293,4.293a1,1,0,1,0,1.414-1.414l-6-6a1,1,0,0,0-1.414,0l-6,6a1,1,0,0,0,1.414,1.414Z",
  fill: "#424b58"
}))));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 50,
    height: 42,
    viewBox: "0 0 50 42"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/upload.c705d55e.svg";
export { SvgComponent as ReactComponent };